/* v8 ignore start */
export namespace NumberUtils {
  export function round(value: number, precision: number = 0): number {
    const multiplier = Math.pow(10, precision);

    return Math.round(value * multiplier) / multiplier;
  }
}
/* v8 ignore stop */
